var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacade2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "210mm",
    viewBox: "0 0 210 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.486 138.75v-15l103.92 60v15z",
    fill: "#0070ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 138.75v10l103.92 60v-10z",
    fill: "#ffb2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 113.75v-15l103.92 60v15z",
    fill: "#0070ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 113.75v10l103.92 60v-10z",
    fill: "#ffb2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 88.75v-15l103.92 60v15z",
    fill: "#0070ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 88.75v10l103.92 60v-10z",
    fill: "#ffb2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.41 133.75 47.631-27.5v15l-47.631 27.5z",
    fill: "#004399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.41 148.75v10l47.631-27.5v-10z",
    fill: "#b27d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 63.75v10l103.92 60v-10z",
    fill: "#ffb2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.41 123.75v10l47.631-27.5v-10z",
    fill: "#996b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.41 158.75 47.631-27.5v15l-47.631 27.5z",
    fill: "#004399"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m123.41 173.75v10l47.631-27.5v-10z",
    fill: "#b27d7d",
    fillOpacity: 0.99254,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.41 183.75 47.631-27.5v15l-47.631 27.5z",
    fill: "#049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.41 198.75v10l47.631-27.5v-10z",
    fill: "#b27d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 63.75 103.92 60 47.631-27.5-103.92-60z",
    fill: "#ffb4b4"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#747474",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.486 73.75-4.3301 2.5 108.25 62.5 51.962-30-4.3301-2.5-47.631 27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 98.75-4.3301 2.5 108.25 62.5 51.962-30-4.3301-2.5-47.631 27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.486 123.75-4.3301 2.5 108.25 62.5 51.962-30-4.3301-2.5-47.631 27.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f00",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.89 97.5s-15.096-11.285 0-25c16.959-15.408 0-25 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.91 107.5s-15.096-11.285 0-25c16.959-15.408 0-25 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.92 75s-15.096-11.285 0-25c16.959-15.408 0-25 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.971 61.75s-15.096-11.285 0-25c16.959-15.408 0-25 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.942 85s-15.096-11.285 0-25c16.959-15.408 0-25 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.282 55s-15.096-11.285 0-25c16.959-15.408 0-25 0-25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacade2);
export default __webpack_public_path__ + "static/media/facade2.86b5499612dbcd52ba7a1a00d22a81fa.svg";
export { ForwardRef as ReactComponent };